module.exports = __webpack_public_path__ + "static/media/sc.31b28e87.svg";